import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/AppContext";
import "./Css/Login.css";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { baseUrl, isAdmin } = useContext(AppContext);
  const [error, setError] = useState("");
  const [role, setRole] = useState("user");
  const navigate = useNavigate();
  //const adminurl =  "https://htmlgames4u.com/api";
  const handleRegister = async (e) => {
    try {
      e.preventDefault();
      const res = await axios.post(`${baseUrl}/register`, {
        email,
        password,
        role,
      });
      navigate("/backbone/login");
      console.log("register", res.data.message);
    } catch (err) {
      console.error("Registration failed", err.response?.data || err.message);
      setError(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Register</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleRegister}>
          <div className="form-row">
            <label>Email</label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
            />
          </div>
          <div className="form-row">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
            />
          </div>
          {isAdmin && (
            <div className="form-row">
              <label>Select role</label>
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
              >
                <option value="">Select role</option>
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
            </div>
          )}

          <button type="submit" className="login-btn">
            Register
          </button>
        </form>
      </div>
    </div>
  );
}
